import { OVERLAY_CARD_IMAGE_HEIGHT } from '@/app/components/search/components/Card/Gallery/styled.ts';
import { OVERLAY_WIDTH } from '@/app/components/search/components/Card/constants.ts';
import type { ImageSize } from '@/app/components/search/utils/images.ts';

/**
 * Size of the box the gallery image is painted into, in CSS pixels. It feeds the `width`/`height`
 * attributes and the CDN transformation alike, so the image requested is the image displayed.
 *
 * The desktop height is the one exception: the card paints CARD_MIN_HEIGHT (200px), but that is a
 * minimum and the image stretches with a card whose content column runs taller, so the 273px the
 * classic card has always asked for stays. `object-fit: cover` trims whatever is surplus.
 */
export const getImageSize = ({
  isOverlay,
  isMobile,
  imagesCount,
}: {
  isOverlay: boolean;
  isMobile: boolean;
  imagesCount: number;
}): ImageSize => {
  if (isOverlay && isMobile) {
    return {
      width: 110,
      height: 136,
    };
  }
  if (isOverlay) {
    return {
      width: parseInt(OVERLAY_WIDTH, 10),
      height: OVERLAY_CARD_IMAGE_HEIGHT,
    };
  }
  if (isMobile && imagesCount !== 1) {
    return {
      width: 230,
      height: 200,
    };
  }
  if (isMobile && imagesCount === 1) {
    return {
      width: 260,
      height: 200,
    };
  }
  return {
    width: 260,
    height: 273,
  };
};
